export const URLS_LIST_NOT_TO_SHOW_LOADING_SPINNER = ['/assets/', 'UserConsent/consentCookie', 'Crm/companies', 'Crm/company/cnpj'];
